<div *ngIf="loading !== undefined ? loading : (loader.loading$ | async)" [ngClass]="{ cover: cover }" role="status" aria-label="Loading">
  <div class="kt-spinner kt-spinner--v2 kt-spinner--lg kt-spinner--brand" aria-hidden="true"></div>
</div>
